import { Component, input, model, output } from '@angular/core';
import { FormValueControl } from '@angular/forms/signals';

@Component({
  imports: [],
  selector: 'ui-checkbox-group',
  templateUrl: './checkbox-group.html',
  styleUrl: './checkbox-group.css',
})
export class CheckboxGroup implements FormValueControl<string[]> {
  readonly value = model<string[]>([]);
  readonly disabled = input<boolean>(false);
  readonly touched = model<boolean>(false);

  fieldValueChange = output<string[]>();

  onCheckOption(value: string): void {
    this.value.update((v) => [...v, value]);
    this.touched.set(true);
    this.fieldValueChange.emit(this.value());
  }

  onUncheckOption(value: string): void {
    this.value.update((v) => v.filter((v) => v !== value));
    this.touched.set(true);
    this.fieldValueChange.emit(this.value());
  }
}
